import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { FormService } from '../../../services/form.service';
import { NmDetailPageClass } from '../../../shared/nm-detail-page-class';

@Component({
	selector: 'marketing-plans-detail-page',
	templateUrl: './detail.html'
})
export class UsersDetailPage extends NmDetailPageClass {
	public modelName: string = 'user';

	public form: FormGroup = this.formBuilder.group({
		email: ['', Validators.compose([Validators.required, this._form.validateEmail])],
		//locale: ['', Validators.required],
		name: ['', Validators.required],
		//roles: ['', Validators.required],
		//status: ['', Validators.required],
		//type: ['', Validators.required],
		password: ['',this.action=='edit'?'':Validators.required],
		//password_verification: ['']
	});

	public onBeforeSubmit(data: any) {
		console.log(data);
		//return false;
		return data;
	}
}


// WEBPACK FOOTER //
// ./src/pages/users/detail/detail.ts